import React from 'react';

import IMG_LOGO from 'assets/slickpay-splash/logoes/Slickpay.png';
import ExternalLink from 'components/generic/ExternalLink.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './SlickPayTopContainer.module.scss';

const ROADMAP_LINK = 'https://help.getslick.com/en/articles/6805149-slickpay-card-reader-faqs';

const SlickPayTopContainer = () => {
  const { t } = useTranslation();
  return (
    <section data-bem="SlickPayTopContainer" className={CN.topContainer}>
      <div className={CN.row}>
        <div data-bem="SlickPayTopContainer__logo" className={CN.logo}>
          <img src={IMG_LOGO} alt="Slick logo" />
        </div>
        <ExternalLink link={ROADMAP_LINK}>
          <div className={CN.question}>{t('slickPay.gotQuestions')}</div>
        </ExternalLink>
      </div>
      <div className={CN.row}>
        <div className={CN.title}>{t('slickPay.cardReader')}</div>
      </div>
    </section>
  );
};
export default SlickPayTopContainer;
